import React from "react"
import './Surrounding.css'

const Surrounding = () => {
  return (
    <div data-aos="fade-up"
      data-aos-duration="1000">
      <div className="surrounding">
        <h3>SURROUNDINGS</h3>
        <video src="./SquarePhotos/Surrounding/Squaresurroundings.mp4" controls></video>
      </div>
      <div className="location">
        <h3>LOCATION</h3>
        <div className="location-map">
          <iframe
            title="unique"
            src="https://www.google.com/maps?q=Avenue+One+Square,31.3736413,74.2579645&output=embed"
            width="100%"
            height="300"
            style={{ border: "0", marginTop: "35px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  )
}

export default Surrounding